import { createContext } from 'react';

type ThemeContextType = {
  mode: 'light' | 'dark';
  toggleColorMode: () => void;
};

export const ThemeContext = createContext<ThemeContextType>({
  mode: 'light',
  toggleColorMode: () => {},
});